const freelyEditableEventTypes = new Set<ScheduleEventType>(["ABSENCE", "INTERNAL_BLOCK"])

type MovableScheduleEvent = Pick<ScheduleEvent, "event_type">

export const canResizeCalendarEventByDrag = (event?: MovableScheduleEvent | null): boolean =>
  isAppointmentCalendarEvent(event) || isFreelyEditableCalendarEvent(event)

export const isAppointmentCalendarEvent = (
  event?: Pick<ScheduleEvent, "event_type"> | null,
): boolean => event?.event_type === "APPOINTMENT"

export const isFreelyEditableCalendarEvent = (event?: MovableScheduleEvent | null): boolean =>
  Boolean(event?.event_type && freelyEditableEventTypes.has(event.event_type))

export const canMoveCalendarEventByDrag = (event?: MovableScheduleEvent | null): boolean =>
  isAppointmentCalendarEvent(event) || isFreelyEditableCalendarEvent(event)
